import { Component, computed, input, OnInit, output } from "@angular/core";
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
} from "@angular/forms";
import { TranslatePipe } from "@ngx-translate/core";
import { Question, Answer, PossibleAnswer } from "src/app/models/question";

@Component({
  selector: "app-quizz-question",
  templateUrl: "./quizz-question.component.html",
  styles: ``,
  imports: [ReactiveFormsModule, TranslatePipe],
})
export class QuizzQuestionComponent implements OnInit {
  question = input.required<Question>();

  shuffleArray<T>(array: T[]): T[] {
    return array
      .map((item) => ({ value: item, sortKey: Math.random() }))
      .sort((a, b) => a.sortKey - b.sortKey)
      .map((entry) => entry.value);
  }

  shuffledAnswers = computed(() => {
    const question = this.question();
    return this.shuffleArray(question.possibleAnswers);
  });

  questionAnswered = output<{
    answer: Answer;
  }>();

  form: FormGroup | undefined;

  ngOnInit(): void {
    this.form = new FormGroup(
      Object.fromEntries(
        this.question().possibleAnswers.map((possibleAnswer) => [
          possibleAnswer.name,
          new FormControl(false, { nonNullable: true }),
        ]),
      ),
      [this.atLeastOneSelectedValidator()],
    );
  }

  atLeastOneSelectedValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const anySelected = Object.values(control.value).some(
        (value) => value === true,
      );
      return anySelected ? null : { atLeastOneRequired: true };
    };
  }

  submit() {
    if (this.form) {
      // console.log(this.form.value);
      const formValue = this.form.value;

      const chosenAnswers: PossibleAnswer[] = [];

      for (const answer of this.question().possibleAnswers) {
        if (answer.name in formValue && formValue[answer.name]) {
          chosenAnswers.push(answer);
        }
      }

      this.questionAnswered.emit({
        answer: {
          answers: chosenAnswers.map((a) => a.name),
          question: this.question().name,
        },
      });
    }
  }
}
